import $ from 'jquery';

$(document).ready(function() {
    $('.js-longrid-materials').slick({
        dots: false,
        slidesToShow: 1.2,
        centerMode: false,
        variableWidth: false,
        arrows: true,
        infinite: false,
        draggable: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.2,
               }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3.2,
               }
            }, 
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 4.2,
               }
            }, 
        ]
    });
    $(window).trigger('resize');
});


// WEBPACK FOOTER //
// ./src/js/pages/longrid/longrid-materials-slider.js